import _ from 'lodash'
import { v4 as uuidv4 } from 'uuid'

import { defaultInstance } from 'services'

import { responseSuccess, responseError } from 'utils/response'
import { removeEmpty } from 'utils'

const getStatuses = () => {
  return [
    { label: 'Active', value: true },
    { label: 'Inactive', value: false },
  ]
}

const statuses = getStatuses()

const getStatusByValue = (value) => {
  return _.find(statuses, { value })
}

const getSignificant = (value) => {
  if (value) return 1
  else return 0
}

const getSignificantByValue = (value) => {
  return _.map({ value }, getSignificant)
}

export const mapReportHeaderType = (item) => {
  const id = item?.report_hd_att_type_id
  return {
    key: uuidv4(),
    id,
    code: item?.report_hd_att_type_code,
    name: item?.report_hd_att_type_name,
    description: item?.report_hd_att_type_desc,
    isEnabled: item?.is_active,
    status: getStatusByValue(item?.is_active),
  }
}

export const mapReportHeaderValue = (item) => {
  const id = item?.report_hd_att_val_id
  return {
    key: uuidv4(),
    impact_type_id: item?.impact_type_id,
    id,
    name: item?.report_hd_att_val_name,
    description: item?.report_hd_att_val_desc,
    score: item?.report_hd_att_val_score,
    is_active: item?.is_active,
    significant: getSignificantByValue(item?.is_significant),
    status: getStatusByValue(item?.is_active),
  }
}

export const getReportHeaderTypeApi = ({ param, is_active }) => {
  const params = { param, is_active }
  const config = {
    method: 'get',
    url: '/api/v1/report_header_attr/type',
    params,
  }
  return defaultInstance
    .request(config)
    .then((res) => {
      if (_.size(res.data) >= 0) {
        return responseSuccess({ data: _.map(res.data?.items, mapReportHeaderType) })
      }
      return responseError({ message: 'API something went wrong' })
    })
    .catch((err) => {
      return responseError({ message: err.message })
    })
}

export const getReportHeaderValueApi = (
  report_header_type_id,
  bu_id,
  impact_type_id,
  { param, is_active }
) => {
  const params = removeEmpty({
    report_header_type_id,
    bu_id,
    impact_type_id,
    param,
    is_active,
  })
  const config = {
    method: 'get',
    url: `/api/v1/report_header_attr/value/${params.report_header_type_id}`,
    params,
  }
  return defaultInstance
    .request(config)
    .then((res) => {
      if (_.size(res.data) >= 0) {
        return responseSuccess({ data: { items: _.map(res.data.values, mapReportHeaderValue) } })
      }
      return responseError({ message: 'API something went wrong' })
    })
    .catch((err) => {
      return responseError({ message: err.message })
    })
}

export const createReportHeaderValueApi = ({
  report_header_type_id,
  report_hd_att_val_name,
  report_hd_att_val_desc,
  report_hd_att_val_score,
  is_active,
  is_significant,
  bu_id,
  impact_type_id,
}) => {
  const id = report_header_type_id
  const data = {
    report_hd_att_val_name,
    report_hd_att_val_desc,
    report_hd_att_val_score,
    is_active,
    is_significant,
    bu_id,
    impact_type_id,
  }
  const config = {
    method: 'post',
    url: `/api/v1/report_header_attr/value/${id}`,
    data,
  }

  return defaultInstance
    .request(config)
    .then((res) => {
      if (res.data) {
        return responseSuccess({ data: res.data })
      }
      return responseError({ message: 'API something went wrong' })
    })
    .catch((err) => {
      if (err.response) {
        return responseError({ message: err.response.data?.message })
      } else if (err.request) {
        console.log('err.request', err.request)
        return responseError({ message: 'API something went wrong' })
      }
      return responseError({ message: err.message })
    })
}

export const updateReportHeaderValueByIdApi = ({
  report_hd_att_val_id,
  report_hd_att_val_name,
  report_hd_att_val_desc,
  report_hd_att_val_score,
  is_active,
  is_significant,
  impact_type_id,
}) => {
  const id = report_hd_att_val_id
  const data = {
    report_hd_att_val_name,
    report_hd_att_val_desc,
    report_hd_att_val_score,
    is_active,
    is_significant,
    impact_type_id,
  }

  const config = {
    method: 'patch',
    url: `/api/v1/report_header_attr/value/${id}`,
    data,
  }

  return defaultInstance
    .request(config)
    .then((res) => {
      if (res.data) {
        return responseSuccess({ data: res.data })
      }
      return responseError({ message: 'API something went wrong' })
    })
    .catch((err) => {
      if (err.response) {
        return responseError({ message: err.response.data?.message })
      } else if (err.request) {
        console.log('err.request', err.request)
        return responseError({ message: 'API something went wrong' })
      }
      return responseError({ message: err.message })
    })
}

export const deleteReportHeaderValueByIdApi = (id) => {
  const params = {
    report_header_type_id: id,
  }
  const config = {
    method: 'delete',
    url: `/api/v1/report_header_attr/value/${id}`,
    params,
  }

  return defaultInstance
    .request(config)
    .then((res) => {
      if (res.data) {
        return responseSuccess({ data: res.data })
      }
      return responseError({ message: 'API something went wrong' })
    })
    .catch((err) => {
      if (err.response) {
        return responseError({ message: err.response.data?.message })
      } else if (err.request) {
        console.log('err.request', err.request)
        return responseError({ message: 'API something went wrong' })
      }
      return responseError({ message: err.message })
    })
}
